export enum ESlackReactionType {
  STAR = 'star',
  LIKE = 'like',
}
